const images = {};
const context = require.context('./', false, /\.(png|jpg)$/);

context.keys().forEach((key) => {
  const name = key.replace('./', '').replace(/\.(png|jpg)$/, '');
  images[name] = context(key);
});

export default images;
